import { Theme, webLightTheme } from "@fluentui/react-components";

export const slThemeLight: Theme = { ...webLightTheme };
